import { Navigate, Route, Routes } from "react-router-dom";

import { Dashboard } from "@/routes/Dashboard";
import { Digest } from "@/routes/Digest";
import HomePage from "@/routes/HomePage";
import { LaneBoard } from "@/routes/LaneBoard";
import LoginPage from "@/routes/LoginPage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={<HomePage />} />
      {/* Phase 7.2: triage lane board + management digest. */}
      <Route path="/lanes" element={<LaneBoard />} />
      <Route path="/digest" element={<Digest />} />
      {/* Legacy 3-bucket view kept as the "show everything" escape
          hatch (brief §9). */}
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
